export default "__VITE_ASSET__L4vW0RId__"